const API_PATH = 'https://conmigo-api.intelligential.tech';
const POSTHOG_TOKEN = 'phc_tEj4zNLa7fSoukq2wArPfDpcKzpCYpY6PihedJt2V88o';
const POSTHOG_HOST = 'https://us.i.posthog.com';

const config = {
  api: {
    url: `${API_PATH}/api`,
  },
  telemetry: {
    token: POSTHOG_TOKEN,
    host: POSTHOG_HOST,
  },
};

export default config;
